var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolatilityHigh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.824 6.001a1.164 1.164 0 011.097.97l3.147 18.61 2.57-18.576a1.164 1.164 0 012.304-.018l2.962 19.274 3.561-19.308a1.164 1.164 0 012.296.034l2.858 18.595 2.858-18.595a1.164 1.164 0 012.285-.087l3.207 13.766a1.164 1.164 0 01-2.268.528l-1.838-7.891-3.093 20.12a1.164 1.164 0 01-2.302 0l-2.962-19.274-3.561 19.308a1.164 1.164 0 01-2.296-.034l-2.798-18.2-2.515 18.183a1.164 1.164 0 01-2.302.034L7.527 12.695l-2.236 8.53a1.164 1.164 0 01-2.253-.59L6.646 6.868c.14-.53.63-.892 1.178-.868z"
  })));
}
export default SvgVolatilityHigh;